exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ul-errors{padding-left:0;background-color:#ffe2e4;color:#d27c82;margin-bottom:15px;padding:9px;box-shadow:0 6px 30px rgba(0,0,0,.1);border-left:3px solid #eab3b7;background-color:#fff}.ul-errors li{font-size:13px;color:#6c757d;letter-spacing:.5px;margin:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6e03fb0b","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app_modules/Errors.vue
// module id = 175
// module chunks = 0